@let _defaultResource = defaultResource();

@if (_defaultResource) {
  @let _compareResource = compareResource();

  @if (_defaultResource.type === 'IMAGE') {
    <div class="image" (click)="toggleFullScreen(_defaultResource.value, _compareResource?.value)">
      <div class="image-container" #compareImageContainer></div>
      <div class="image-container" #imageContainer></div>
    </div>
  } @else {
    <div class="text-end w-100">
      @if (_compareResource) {
        <span class="apm-text-gray" [ngClass]="field.className">({{ _compareResource.id | apmTranslate }})</span>
      }
      {{ _defaultResource.id | apmTranslate }} {{ props.uom }}
    </div>
  }
}
